import React from "react";
import "./pop-up-generic.css";

const PopupGeneric = ({ isVisible, onClose, title, content, actions }) => {
  if (!isVisible) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="popup-close" onClick={onClose}>
          &times;
        </button>

        {title && <div className="popup-title">{title}</div>}

        <div className="popup-body">
          {content}
        </div>

        {actions && (
          <div className="popup-actions">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupGeneric;
